<script>
import { defineComponent } from 'vue';
import config from '@/config/client';

const component = defineComponent({
  name: 'CopyrightData',

  data() {
    return {
      appVersion: config.appVersion,
      buildYear: config.buildYear,
      hasCookiebot: window.Cookiebot,
    };
  },

  methods: {
    showCookieConsentDialog() {
      window.Cookiebot.renew();
    },
  },

  render() {
    const { appVersion, buildYear, hasCookiebot, showCookieConsentDialog } = this;

    return this.$slots.default({
      appVersion,
      buildYear,
      hasCookiebot,
      showCookieConsentDialog,
    });
  },
});

export default component;
</script>
